import { useLanguage } from '@/contexts/LanguageContext';

/**
 * How far through something a student is.
 *
 * The fill grows from the reading edge — `ms-auto` in a flex row rather than a
 * width on a left-anchored block — so in Arabic it fills from the right, which
 * is the direction the page is read in. The fill is lime: progress is one of
 * the places DESIGN.md spends the lime as a fill, in both palettes.
 */
export function ProgressBar({ percent, label }: { percent: number; label: string }) {
  const { t } = useLanguage();
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      data-testid="progress-bar"
      data-percent={clamped}
      className="h-2 w-full overflow-hidden rounded-full bg-hair"
      title={`${clamped}% — ${t('tracks.yourProgress')}`}
    >
      <div className="h-full rounded-full bg-lime transition-all" style={{ width: `${clamped}%` }} />
    </div>
  );
}
